import {
	getRetailApps,
	moveAppToRetail,
	getRetailPackagesList,
	getRetailPackage,
	addPackage,
	addToPackage,
	removeFromPackage,
	deletePackage,
	changePackageName
} from '../helpers/retailService';
import { checkError, receiveErrorAlert, closeAlert } from './commonsActions';
import {deleteAttribute} from "../helpers/attributesService";
import {fetchAttributes} from "./attributesActions";
import {getApps} from "../helpers/marketService";
import {FETCH_APPS_BEGIN, filteringApps, GET_APPS, getAppsList} from "./marketActions";

/*
 * action types
 */
export const FETCH_ALL_RETAIL_APPS_BEGIN   = 'FETCH_ALL_RETAIL_APPS_BEGIN';
export const FETCH_ALL_RETAIL_APPS_SUCCESS   = 'FETCH_ALL_RETAIL_APPS_SUCCESS';

export const GET_FILTERED_PACKAGES = 'GET_FILTERED_PACKAGES';

export const FETCH_PACKAGES_BEGIN = 'FETCH_PACKAGES_BEGIN';
export const FETCH_PACKAGES_SUCCESS = 'FETCH_PACKAGES_SUCCESS';

export const FETCH_PACKAGE_BEGIN = 'FETCH_PACKAGE_BEGIN';
export const FETCH_PACKAGE_SUCCESS = 'FETCH_PACKAGE_SUCCESS';

export const ADD_APP_TO_PACKAGE_BEGIN = 'ADD_APP_TO_PACKAGE_BEGIN';
export const ADD_APP_TO_PACKAGE_SUCCESS = 'ADD_APP_TO_PACKAGE_SUCCESS';

export const REMOVE_APP_FROM_PACKAGE_BEGIN = 'REMOVE_APP_FROM_PACKAGE_BEGIN';
export const REMOVE_APP_FROM_PACKAGE_SUCCESS = 'REMOVE_APP_FROM_PACKAGE_SUCCESS';

/*
 * action creators
 */

// export const getFilteredAppsList = apps => ({
// 	type: GET_FILTERED_APPS,
// 	apps
// });

export const getRetailAppsList = query => dispatch => {
	dispatch({ type: FETCH_ALL_RETAIL_APPS_BEGIN });
	return getRetailApps(query).then(res => {
		dispatch({
			type: FETCH_ALL_RETAIL_APPS_SUCCESS,
			payload: {
				apps: res.data,
				numberOfElements : res.numberOfElements,
				totalElements: res.totalElements,
				totalPages: res.totalPages
			}
		});
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const getRetailPackageList = (query) => dispatch => {
	dispatch({ type: FETCH_PACKAGE_BEGIN });
	return getRetailPackage(query).then(res => {
		dispatch({
			type: FETCH_PACKAGE_SUCCESS,
			payload: {
				packageApps: res.data,
				numberOfElements : res.numberOfElements,
				totalElements: res.totalElements,
				totalPages: res.totalPages
			}
		});
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const moveSingleAppToRetail = appId => dispatch => {
	return moveAppToRetail(appId).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const fetchPackages = query => dispatch => {
	dispatch({ type: FETCH_PACKAGES_BEGIN });
	return getRetailPackagesList(query).then(res => {
		dispatch({
			type: FETCH_PACKAGES_SUCCESS,
			payload: {
				packages: res.data,
				numberOfElements : res.numberOfElements,
				totalElements: res.totalElements,
				totalPages: res.totalPages
			}
		});
		dispatch(filteringPackages());
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const filteringPackages = filterWord => (dispatch, getState) => {
	const state = getState();
	let filteredPackages = null;
	if (filterWord) {
		filteredPackages = state.packagesList.packages.filter( item => {
			return item.name.toLowerCase().indexOf(filterWord.toLowerCase()) !== -1;
		});
	} else {
		filteredPackages = state.packagesList.packages;
	}

	dispatch({
		type: GET_FILTERED_PACKAGES,
		filteredPackages
	});
};

export const saveNewPackage = (packageName, companyId) => dispatch => {
	return addPackage({
		name: packageName,
		companyId: companyId,
	}).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const removePackage = packageId => dispatch => {
	return deletePackage(packageId).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const changePackName = pack => dispatch => {
	return changePackageName(pack).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const addAppsToPackage = (apps, bundleId) => dispatch => {
	dispatch({ type: ADD_APP_TO_PACKAGE_BEGIN });
	return addToPackage(apps, bundleId).then(res => {
		dispatch({
			type: ADD_APP_TO_PACKAGE_SUCCESS,
			payload: {
				addedPackages: res.data
			}
		});
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};

export const removeAppsFromPackage = (apps, bundleId) => dispatch => {
	dispatch({ type: REMOVE_APP_FROM_PACKAGE_BEGIN });
	return removeFromPackage(apps, bundleId).then(res => {
		dispatch({
			type: REMOVE_APP_FROM_PACKAGE_SUCCESS,
			payload: {
				removedPackages: res.data
			}
		});
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};



// WEBPACK FOOTER //
// ./src/actions/retailActions.js